import { AudioManager } from "./AudioManager";
import { GameVars } from "../GameVars";
import { GameManager } from "./GameManager";
import { RoomScene } from "../scenes/room/RoomScene";
import { GameConstants } from "../GameConstants";

export class RoomManager {

    private static game: Phaser.Game;

    private static playerQueued: boolean;
    private static playerQueuedChips: number;

    public static get IsPlayerQueued() {
        return RoomManager.playerQueued;
    }

    public static init(game: Phaser.Game): void {

        RoomManager.game = game;

        GameVars.paused = false;
        GameVars.gameOver = false;

        GameVars.betValue = 10;
        GameVars.callValue = GameVars.betValue;
        GameVars.raiseValue = 2 * GameVars.betValue;
        GameVars.playerId = "Player";
        GameVars.gameSpeed = GameConstants.INITIAL_SPEED;
        GameVars.blindsPosition = 0;

        if (GameConstants.AI_MODE) {
            GameVars.gameSpeed = 20;
        }
    }

    public static getIds(count: number): string[] {

        let ids = [];
        let keys = Object.keys(GameVars.botsInfo);

        return keys.sort(() => 0.5 - Math.random()).slice(0, count);
    }

    public static startNewHand(first?: boolean): void {

        RoomScene.currentInstance.startNewHand(first);
    }

    public static onBackButtonPressed(): void {

        GameVars.paused = true;

        const hasMatchStarted = true;

        if (hasMatchStarted) {
            RoomScene.currentInstance.showQuitLayer();
        } else {
            GameManager.roomToSplash();
        }
    }

    public static onWinningHandsPressed(): void {

        RoomScene.currentInstance.showWinningHandsLayer();
    }

    public static removeQuitLayer(): void {

        GameVars.paused = false;

        RoomScene.currentInstance.removeQuitLayer();
    }

    public static showCardsButtons(): void {

        RoomScene.currentInstance.showCardsButtons();
    }


    public static initPokerState(ids: string[], chips: number, bigBlind: number): void {

        if (RoomManager.playerQueued) {
            RoomManager.playerQueued = false;
            let player: PlayerState = {
                id: "Player",
                state: GameConstants.ACTIVE,
                cards: [],
                chips: RoomManager.playerQueuedChips,
                wagered: 0,
                poted: 0,
                position: 0,
                self: true,
                payout: 0,
                actions: {},
                x: 0,
                y: 0,
            };
            GameVars.gameState.players.unshift(player);
            for (let i = 0; i < GameVars.gameState.players.length; i++) {
                GameVars.gameState.players[i].position = i;
            }
            GameVars.gameState.players[0].state = GameConstants.INACTIVE;
            return;
        } else {
            let players = [];

            for (let i = 0; i < ids.length; i++) {

                let player: PlayerState = {
                    id: ids[i],
                    state: GameConstants.ACTIVE,
                    cards: [],
                    chips: chips,
                    wagered: 0,
                    poted: 0,
                    position: i,
                    self: i === 0,
                    payout: 0,
                    actions: {},
                    x: 0,
                    y: 0
                };

                players.push(player);
            }

            players[0].state = GameConstants.INACTIVE;

            let state: PokerGameState = {
                hand: 0,
                community: [],
                state: GameConstants.PRE_FLOP,
                players: players,
                bigBlind: bigBlind,
                smallBlind: bigBlind / 2,
                call: bigBlind,
                raise: bigBlind,
                pot: 0
            };
            GameVars.gameState = state;
        }
    }

    public static queueRejoinPlayer(chips: number) {
        RoomManager.playerQueued = true;
        RoomManager.playerQueuedChips = chips;
    }

    public static rejoinPlayerIfQueued() {
        if (RoomManager.playerQueued) {
            GameVars.currentScene.scene.stop("RoomScene");
            setTimeout(() => {
                GameVars.currentScene.scene.start("RoomScene");
            }, 1);
            return;
        }
    }


    public static resetCommunity(): void {



        RoomManager.log("");
        RoomManager.log("NEW HAND (" + GameVars.gameState.hand + ")");

        GameVars.gameState.community = [];
        GameVars.gameState.pot = 0;
        GameVars.gameState.state = GameConstants.PRE_FLOP;
        GameVars.gameState.hand++;

        if (GameVars.gameState.hand % 5 === 0 && GameVars.gameState.hand !== 0) {

            if (GameVars.blindsPosition < GameConstants.BIG_BLINDS.length) {
                // TO DO: mandar mensaje en pantalla de que suben las ciegas
                GameVars.blindsPosition++;
                GameVars.gameState.bigBlind = GameConstants.BIG_BLINDS[GameVars.blindsPosition];
                GameVars.gameState.smallBlind = GameConstants.BIG_BLINDS[GameVars.blindsPosition] / 2;

                if (GameVars.gameState.players.length > 1) {
                    RoomScene.currentInstance.showBananaRise();
                }
            }
        }

        RoomScene.currentInstance.updateInfo();
    }

    public static setPlayersNewHand(): void {

        GameVars.allin = false;

        // set new position

        let players = GameVars.gameState.players;
        let sb = GameVars.gameState.smallBlind;
        let bb = GameVars.gameState.bigBlind;

        players = players.sort(RoomManager.sortPrayersByPosition);

        for (let i = 0; i < players.length; i++) {
            players[i].position = i;
        }

        for (let i = 0; i < players.length; i++) {
            players[i].position = players[i].position === 0 ? players.length - 1 : players[i].position - 1;
            players[i].wagered = 0;
            players[i].poted = 0;
            players[i].state = GameConstants.ACTIVE;
            players[i].cards = [];
            players[i].payout = 0;
            players[i].actions = {};
        }

        players = players.sort(RoomManager.sortPrayersByPosition);

        // set bb and sb

        for (let i = 0; i < players.length; i++) {

            players[i].position = i;

            if (i === 0) {
                players[i].wagered = players[i].chips > sb ? sb : players[i].chips;
                RoomManager.log(players[i].id + " sb: " + players[i].wagered);

                RoomScene.currentInstance.updateBets(players[i].id);
            } else if (i === 1) {
                players[i].wagered = players[i].chips > bb ? bb : players[i].chips;
                RoomManager.log(players[i].id + " bb: " + players[i].wagered);

                GameVars.gameState.call = bb;
                GameVars.gameState.raise = bb + sb;

                RoomScene.currentInstance.updateBets(players[i].id);
            }
        }

        RoomScene.currentInstance.updatePot();

    }

    public static newCards(): void {

        GameVars.cards = ["Ad", "Kd", "Qd", "Jd", "Td", "9d", "8d", "7d", "6d", "5d", "4d", "3d", "2d",
            "As", "Ks", "Qs", "Js", "Ts", "9s", "8s", "7s", "6s", "5s", "4s", "3s", "2s",
            "Ac", "Kc", "Qc", "Jc", "Tc", "9c", "8c", "7c", "6c", "5c", "4c", "3c", "2c",
            "Ah", "Kh", "Qh", "Jh", "Th", "9h", "8h", "7h", "6h", "5h", "4h", "3h", "2h"];

        for (let i = GameVars.cards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [GameVars.cards[i], GameVars.cards[j]] = [GameVars.cards[j], GameVars.cards[i]];
        }
    }

    public static dealPlayersCards(): void {

        RoomManager.log("");
        RoomManager.log("CARDS");

        for (let i = 0; i < GameVars.gameState.players.length; i++) {

            let player = GameVars.gameState.players[i];

            player.cards.push(GameVars.cards.shift());
            player.cards.push(GameVars.cards.shift());

            RoomManager.log(player.id + ": [" + player.cards + "]");
        }
    }

    public static getNextBet(): void {

        let playersWithChips = RoomManager.playersWithChips();

        if (playersWithChips.length === 0 || (playersWithChips.length === 1 && playersWithChips[0].wagered >= GameVars.gameState.call)) {
            if (!GameVars.allin) {
                GameVars.allin = true;
                GameVars.allinSince = GameVars.gameState.state;
            }
        }

        let idPlayers = RoomManager.playersActive();

        // si solo queda un jugador ya es el ganador
        if (idPlayers.length === 1) {
            RoomManager.nextState();
            return;
        }

        if (GameVars.lastTurn === GameVars.currentTurn) {

            if (GameVars.firstLoop) {

                let players = GameVars.gameState.players;
                let player = players[GameVars.currentTurn];

                if (!GameVars.allin && player.chips - player.wagered > 0) {
                    if (player.self) {
                        RoomScene.currentInstance.playerTurn();
                    } else {
                        RoomScene.currentInstance.getBet(player.id);
                    }
                } else {
                    RoomManager.nextState();
                }

            } else {

                RoomManager.nextState();
            }

        } else {

            let players = GameVars.gameState.players;
            let player = players[GameVars.currentTurn];

            if (player.state === GameConstants.ACTIVE) {

                if (!GameVars.allin && player.chips - player.wagered > 0) {
                    if (player.self) {
                        RoomScene.currentInstance.playerTurn();
                    } else {
                        RoomScene.currentInstance.getBet(player.id);
                    }
                } else {
                    RoomManager.setCurrentTurn();
                    RoomManager.getNextBet();
                }

            } else {

                RoomManager.setCurrentTurn();
                RoomManager.getNextBet();
            }

        }

        RoomScene.currentInstance.setValueButtons();
    }

    public static updateActions(bet: number, id: string): void {

        let player = RoomManager.getPlayer(id);
        let state = GameVars.gameState.state;
        let type = "";

        if (!player.actions[state]) {
            player.actions[state] = [];
        }

        if (bet > GameVars.gameState.call) {
            type = GameConstants.RAISE;
        } else if (bet < GameVars.gameState.call && bet !== player.chips) {
            type = GameConstants.FOLD;
        } else if (bet === 0 || bet === player.wagered) {
            type = GameConstants.CHECK;
        } else {
            type = GameConstants.CALL;
        }

        player.actions[state].push({ type: type, bet: bet });
    }

    public static changeSpeed(speed: number): void {

        GameVars.gameSpeed = speed;
    }

    public static playerBet(bet: number): void {

        // RoomScene.currentInstance.unmarkPlayers();

        let players = GameVars.gameState.players;
        let player = players[GameVars.currentTurn];

        if (GameVars.lastTurn === GameVars.currentTurn) {
            RoomManager.setBetFirstLoop(player, bet);
        } else {
            RoomManager.setBet(player, bet);
        }

    }

    public static showBananaPopcorns(): void {

        RoomScene.currentInstance.showBananaPopcorns();
    }

    public static hideBananaPopcorns(): void {

        RoomScene.currentInstance.hideBananaPopcorns();
    }

    public static setBetFirstLoop(player: PlayerState, bet: number): void {


        if (bet > GameVars.gameState.call) {

            GameVars.lastTurn = GameVars.currentTurn;
            GameVars.firstLoop = false;

            RoomManager.setBetToState(bet, bet === player.chips ? GameConstants.ALL_IN : GameConstants.RAISE);
            RoomManager.log(player.id + " bet: " + bet);

            RoomManager.setCurrentTurn();

            RoomManager.getNextBet();

        } else {

            let type;

            if (bet === 0 || bet === player.wagered) {
                type = GameConstants.CHECK;
            } else if (bet === player.chips) {
                type = GameConstants.ALL_IN;
            } else {
                type = GameConstants.CALL;
            }

            RoomManager.setBetToState(bet, type);
            RoomManager.log(player.id + " bet: " + bet);

            GameVars.currentScene.time.addEvent({
                delay: 1000 / GameVars.gameSpeed, callback: () => {
                    RoomManager.nextState();
                }, callbackScope: GameVars.currentScene
            });
        }
    }

    public static setBet(player: PlayerState, bet: number): void {

        if (bet < GameVars.gameState.call && bet !== player.chips) {
            player.state = GameConstants.INACTIVE;
            RoomScene.currentInstance.inactivePlayer(player.id);
        }

        let type;

        if (bet > GameVars.gameState.call) {
            GameVars.lastTurn = GameVars.currentTurn;
            GameVars.firstLoop = false;

            type = GameConstants.RAISE;

            if (bet === player.chips) {
                type = GameConstants.ALL_IN;
            }
        } else if (bet < GameVars.gameState.call && bet !== player.chips) {
            type = GameConstants.FOLD;
        } else if (bet === 0 || bet === player.wagered) {
            type = GameConstants.CHECK;
        } else if (bet === player.chips) {
            type = GameConstants.ALL_IN;
        } else {
            type = GameConstants.CALL;
        }

        RoomManager.setBetToState(bet, type);
        RoomManager.log(player.id + " bet: " + bet);

        RoomManager.setCurrentTurn();

        GameVars.currentScene.time.addEvent({
            delay: 1000 / GameVars.gameSpeed, callback: () => {
                RoomManager.getNextBet();
            }, callbackScope: GameVars.currentScene
        });

    }

    public static setCurrentTurn(): void {

        let players = GameVars.gameState.players;

        GameVars.currentTurn = GameVars.currentTurn === GameVars.gameState.players.length - 1 ? 0 : GameVars.currentTurn + 1;

        while (players[GameVars.currentTurn].state !== GameConstants.ACTIVE) {
            GameVars.currentTurn = GameVars.currentTurn === GameVars.gameState.players.length - 1 ? 0 : GameVars.currentTurn + 1;
        }
    }

    public static nextState(): void {

        let idPlayers = RoomManager.playersActive();

        GameVars.gameState.call = 0;
        GameVars.gameState.raise = GameVars.gameState.smallBlind;

        if (idPlayers.length === 1) {
            RoomManager.addWageredToPot();
            RoomManager.updatePlayersPot(idPlayers, GameVars.gameState.pot, 0);
            RoomManager.showWinner(idPlayers);
            return;
        }

        let playersWithChips = RoomManager.playersWithChips();

        if (playersWithChips.length === 0 || (playersWithChips.length === 1 && playersWithChips[0].wagered >= GameVars.gameState.call)) {
            if (GameVars.gameState.state !== GameConstants.RIVER) {
                if (!GameVars.allin) {
                    GameVars.allin = true;
                    GameVars.allinSince = GameVars.gameState.state;
                }
                AudioManager.playSound("all_in_sequence", false, true);
                RoomScene.currentInstance.showAllinBackground();
            }
        }

        if (GameVars.gameState.state === GameConstants.PRE_FLOP) {
            RoomManager.endPreflop();
        } else if (GameVars.gameState.state === GameConstants.FLOP) {
            RoomManager.endFlop();
        } else if (GameVars.gameState.state === GameConstants.TURN) {
            RoomManager.endTurn();
        } else {
            RoomManager.endRiver();
        }
    }

    public static playersActive(): string[] {

        let ids = [];

        for (let i = 0; i < GameVars.gameState.players.length; i++) {

            if (GameVars.gameState.players[i].state !== GameConstants.INACTIVE) {
                ids.push(GameVars.gameState.players[i].id);
            }
        }

        return ids;
    }

    public static playersWithChips(): PlayerState[] {

        let players = [];

        for (let i = 0; i < GameVars.gameState.players.length; i++) {

            let player = GameVars.gameState.players[i];

            if (player.state === GameConstants.ACTIVE && player.chips - player.wagered > 0) {
                players.push(player);
            }
        }

        return players;
    }

    public static numPlayerWithChips(): number {

        let num = 0;

        for (let i = 0; i < GameVars.gameState.players.length; i++) {

            let player = GameVars.gameState.players[i];

            if (player.state === GameConstants.ACTIVE && player.chips > 0) {
                num++;
            }
        }

        return num;
    }

    public static preflop(): void {

        RoomManager.log("");
        RoomManager.log("START PREFLOP");

        let players = GameVars.gameState.players;
        GameVars.currentTurn = players.length === 2 ? 0 : 2;
        GameVars.lastTurn = 1;
        GameVars.firstLoop = true;

        RoomManager.getNextBet();
    }

    public static setBetToState(bet: number, type: string): void {

        let player = GameVars.gameState.players[GameVars.currentTurn];
        if (bet !== 0) {
            player.wagered = bet;

            if (bet > GameVars.gameState.call) {
                GameVars.gameState.raise = bet + bet - GameVars.gameState.call;
                GameVars.gameState.call = bet;
            }

        }

        RoomScene.currentInstance.updatePot();

        if (type !== GameConstants.FOLD) {
            RoomScene.currentInstance.hideCurrentPlayerCards();
        }

        if (player.id === GameVars.playerId) {
            GameVars.gameData.chips = GameVars.initialChips + player.chips - player.wagered;
            GameManager.writeGameData();
        }

        RoomScene.currentInstance.updateBets(player.id, type);

    }

    public static endPreflop(): void {

        RoomManager.log("END PREFLOP");
        RoomManager.log("");

        RoomManager.addWageredToPot();

        if (RoomManager.numPlayerWithChips() <= 1) {
            RoomScene.currentInstance.showCards();

            GameVars.currentScene.time.addEvent({
                delay: 1000 / GameVars.gameSpeed, callback: () => {
                    GameVars.gameState.state = GameConstants.FLOP;
                    RoomManager.flop();
                }, callbackScope: GameVars.currentScene
            });
        } else {
            GameVars.gameState.state = GameConstants.FLOP;
            RoomManager.flop();
        }


    }

    public static flop(): void {

        RoomManager.log("START FLOP");

        GameVars.gameState.community.push(GameVars.cards.shift());
        GameVars.gameState.community.push(GameVars.cards.shift());
        GameVars.gameState.community.push(GameVars.cards.shift());

        RoomManager.log("Community cards: " + GameVars.gameState.community);

        RoomScene.currentInstance.updateCommunityCards();
        // RoomScene.currentInstance.resetBets();

        GameVars.currentTurn = 0;
        RoomManager.setLastTurn();
        GameVars.firstLoop = true;

        GameVars.currentScene.time.addEvent({
            delay: (2000 * RoomManager.getAllinMult()) / GameVars.gameSpeed, callback: () => {
                RoomManager.getNextBet();
            }, callbackScope: GameVars.currentScene
        });
    }

    public static endFlop(): void {

        RoomManager.log("END FLOP");
        RoomManager.log("");

        RoomManager.addWageredToPot();

        if (RoomManager.numPlayerWithChips() <= 1) {
            RoomScene.currentInstance.showCards();

            GameVars.currentScene.time.addEvent({
                delay: 1000 / GameVars.gameSpeed, callback: () => {
                    GameVars.gameState.state = GameConstants.TURN;
                    RoomManager.turn();
                }, callbackScope: GameVars.currentScene
            });
        } else {
            GameVars.gameState.state = GameConstants.TURN;
            RoomManager.turn();
        }
    }

    public static turn(): void {

        RoomManager.log("START TURN");

        GameVars.gameState.community.push(GameVars.cards.shift());

        RoomManager.log("Community cards: " + GameVars.gameState.community);

        RoomScene.currentInstance.updateCommunityCards();
        // RoomScene.currentInstance.resetBets();

        GameVars.currentTurn = 0;
        RoomManager.setLastTurn();
        GameVars.firstLoop = true;

        GameVars.currentScene.time.addEvent({
            delay: (2000 * RoomManager.getAllinMult()) / GameVars.gameSpeed, callback: () => {
                RoomManager.getNextBet();
            }, callbackScope: GameVars.currentScene
        });
    }

    public static endTurn(): void {

        RoomManager.log("END TURN");
        RoomManager.log("");

        RoomManager.addWageredToPot();

        if (RoomManager.numPlayerWithChips() <= 1) {
            RoomScene.currentInstance.showCards();

            GameVars.currentScene.time.addEvent({
                delay: 1000 / GameVars.gameSpeed, callback: () => {
                    GameVars.gameState.state = GameConstants.RIVER;

                    if (RoomManager.getAllinMult() === 3) {
                        GameVars.currentScene.time.addEvent({
                            delay: (2000 * RoomManager.getAllinMult()) / GameVars.gameSpeed, callback: () => {
                                RoomManager.river();
                            }, callbackScope: GameVars.currentScene
                        });
                    } else {
                        RoomManager.river();
                    }
                }, callbackScope: GameVars.currentScene
            });
        } else {

            GameVars.gameState.state = GameConstants.RIVER;

            if (RoomManager.getAllinMult() === 3) {
                GameVars.currentScene.time.addEvent({
                    delay: (2000 * RoomManager.getAllinMult()) / GameVars.gameSpeed, callback: () => {
                        RoomManager.river();
                    }, callbackScope: GameVars.currentScene
                });
            } else {
                RoomManager.river();
            }
        }
    }

    public static river(): void {

        if (GameVars.allin) {
            AudioManager.stopSound("all_in_sequence");
        }

        RoomScene.currentInstance.hideAllinBackground();

        RoomManager.log("START RIVER");

        GameVars.gameState.community.push(GameVars.cards.shift());

        RoomManager.log("Community cards: " + GameVars.gameState.community);

        RoomScene.currentInstance.updateCommunityCards();
        // RoomScene.currentInstance.resetBets();

        GameVars.currentTurn = 0;
        RoomManager.setLastTurn();
        GameVars.firstLoop = true;

        GameVars.currentScene.time.addEvent({
            delay: (2000 * RoomManager.getAllinMult()) / GameVars.gameSpeed, callback: () => {
                RoomManager.getNextBet();
            }, callbackScope: GameVars.currentScene
        });
    }

    public static getAllinMult(): number {

        let mult = 1;

        if (GameVars.allin) {

            switch (GameVars.allinSince) {
                case GameConstants.PRE_FLOP:
                    mult = 1;
                    break;
                case GameConstants.FLOP:
                    mult = 2;
                    break;
                case GameConstants.TURN:
                    mult = 3;
                    break;
                default:
                    break;
            }
        }

        return mult;
    }

    public static endRiver(): void {

        RoomManager.log("END RIVER");

        RoomManager.addWageredToPot();
        // RoomScene.currentInstance.resetBets();

        RoomManager.log("");
        RoomManager.log("POT: " + GameVars.gameState.pot);

        let hands = [];
        let ids = [];
        let pots = [];
        let players = GameVars.gameState.players;

        for (let i = 0; i < players.length; i++) {
            let cards = GameVars.gameState.community.concat(players[i].cards);
            hands.push(Hand.solve(cards));
            ids.push(players[i].id);
            pots.push(players[i].poted);
        }

        let sidePots = [];
        let min = Math.min.apply(null, pots.filter(Boolean));

        while (!pots.every(item => item === 0)) {
            let pot = { value: 0, hands: [], ids: [] };
            for (let i = 0; i < pots.length; i++) {
                if (pots[i] > 0) {
                    pot.value += min;
                    pots[i] -= min;

                    if (players[i].state === GameConstants.ACTIVE) {
                        pot.hands.push(hands[i]);
                        pot.ids.push(ids[i]);
                    }
                }
            }

            sidePots.push(pot);
            min = Math.min.apply(null, pots.filter(Boolean));
        }

        let mainPot = 0;

        for (let i = 0; i < players.length; i++) {
            if (players[i].state === GameConstants.INACTIVE) {
                mainPot += players[i].poted;
            }
        }

        let finalWinners = [];
        let cards = [];
        let handNames = [];

        for (let k = 0; k < sidePots.length; k++) {

            let winners = Hand.winners(sidePots[k].hands);
            let pot = Math.floor(sidePots[k].value / winners.length);
            let dif = sidePots[k].value - (pot * winners.length);
            let winnersIds: string[] = [];

            RoomManager.log("WINNERS (" + pot + ")");

            for (let i = 0; i < sidePots[k].hands.length; i++) {
                for (let j = 0; j < winners.length; j++) {
                    if (winners[j] === sidePots[k].hands[i]) {

                        winnersIds.push(sidePots[k].ids[i]);

                        if (k === 0) {
                            cards.push(winners[j].cards);
                            let handName = winners[j].name;
                            handName = handName.toLowerCase().replace(/ /g, "_");
                            handNames.push(handName);
                            finalWinners = finalWinners.concat(winnersIds);
                        }

                        RoomManager.log("Id : " + sidePots[k].ids[i]);
                        RoomManager.log("Result: " + winners[j].descr);
                    }
                }
            }

            RoomManager.updatePlayersPot(winnersIds, pot, dif);

            for (let i = 0; i < finalWinners.length; i++) {
                RoomManager.getPlayer(finalWinners[i]).payout += pot;
            }
        }

        finalWinners = finalWinners.filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) === index;
        });

        RoomManager.showWinner(finalWinners, cards, handNames);
    }

    public static updatePlayersPot(winnersIds: string[], pot: number, dif: number): void {

        const players = GameVars.gameState.players;

        for (let i = 0; i < players.length; i++) {
            for (let j = 0; j < winnersIds.length; j++) {
                if (winnersIds[j] === players[i].id) {
                    players[i].chips += pot;
                    if (j === 0) {
                        players[i].chips += dif;
                    }
                }
            }
        }

        const player = RoomManager.getPlayer(GameVars.playerId);

        if (player) {
            GameVars.gameData.chips = GameVars.initialChips + player.chips;
            GameManager.writeGameData();
        }
    }

    public static showWinner(winnersIds: string[], cards?: any[], handNames?: string[]): void {

        // rivalry
        for (let i = 0; i < GameVars.gameState.players.length; i++) {

            let player = GameVars.gameState.players[i];
            let winner = false;
            for (let j = 0; j < winnersIds.length; j++) {
                if (player.id === winnersIds[j]) {
                    winner = true;
                }
            }

            if (!winner && player.state === GameConstants.ACTIVE) {
                RoomScene.currentInstance.setPlayerRivalry(player.id, winnersIds);
            }
        }

        const players = GameVars.gameState.players;

        RoomManager.log("");
        RoomManager.log("CHIPS");

        for (let i = 0; i < players.length; i++) {
            RoomManager.log(players[i].id + ": " + players[i].chips);
        }

        RoomScene.currentInstance.showWinners(winnersIds, cards, handNames);
    }

    public static setWinner(): void {

        let player = GameVars.gameState.players[0];

        RoomManager.log("WINNER: " + player.id + " (" + player.chips + ")");

        RoomScene.currentInstance.showWinnerLayer();

    }

    public static getCredibility(id: string): any {

        return RoomScene.currentInstance.getCredibility(id);
    }

    public static addWageredToPot(): void {

        let players = GameVars.gameState.players;

        for (let i = 0; i < players.length; i++) {
            GameVars.gameState.pot += players[i].wagered;
            players[i].chips -= players[i].wagered;
            players[i].poted += players[i].wagered;
            players[i].wagered = 0;
        }

        let player = RoomManager.getPlayer(GameVars.playerId);

        if (player) {
            GameVars.gameData.chips = GameVars.initialChips + player.chips;
            GameManager.writeGameData();
        }

        // RoomScene.currentInstance.addWageredToPot();
    }

    public static setLastTurn(): void {

        let players = GameVars.gameState.players;
        for (let i = players.length - 1; i >= 0; i--) {
            if (players[i].state === GameConstants.ACTIVE) {
                GameVars.lastTurn = i;
                break;
            }
        }
    }

    public static getPlayer(id: string): PlayerState {

        for (let i = 0; i < GameVars.gameState.players.length; i++) {
            if (id === GameVars.gameState.players[i].id) {
                return GameVars.gameState.players[i];
            }
        }
    }

    private static sortPrayersByPosition(a: PlayerState, b: PlayerState): number {

        if (a.position < b.position) {
            return -1;
        } else if (a.position > b.position) {
            return 1;
        } else {
            return 0;
        }
    }

    private static log(message: string): void {

        if (GameConstants.DEVELOPMENT) {
            console.log(message);
        }
    }
}
